<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="checkout-tabs mb-4">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
        <b-tab active>
          <template v-slot:title>
            <div class="d-flex align-items-left justify-content-left">
              <i class="bx bxs-cube bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >SANDBOX</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Sandbox</h5>
                <div class="row mb-2">
                  <div class="col-6">-</div>
                  <div class="col-6 text-right">
                    <b-button
                      class="btn btn-success mr-1 btn-sm text-white"
                      @click="addPrefModal('sandbox')"
                      ><i class="bx bx-plus text-white"> </i>
                      <span class="text-white">{{
                        $t("malware.add-preference")
                      }}</span></b-button
                    >
                  </div>
                </div>
                <div class="table-responsive">
                  <div>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            {{ $t("malware.type") }} & {{ $t("malware.key") }}
                          </th>
                          <th>{{ $t("malware.api-name") }}</th>
                          <th>Detail</th>
                          <th width="10%" class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="pref in tableDataSandbox"
                          :key="pref.id_pref"
                        >
                          <td>
                            <span class="text-success">{{
                              $t("malware.type")
                            }}</span
                            ><br /><span> {{ pref.type }}</span
                            ><br /><br />
                            <span class="text-success">{{
                              $t("malware.key")
                            }}</span
                            ><br /><span> {{ pref.key }}</span>
                          </td>
                          <td>{{ pref.api_name }}</td>
                          <td>
                            <span class="text-success" v-if="pref.api_host"
                              >Api Host</span
                            >
                            <br /><span> {{ pref.api_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_host"
                              >Api Header Host</span
                            >
                            <br />
                            <span> {{ pref.api_header_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_key"
                              >Api Header Key</span
                            ><br /><span>
                              {{ pref.api_header_key_secret }}</span
                            >
                            <br /><br />
                            <!-- <span
                              class="text-success"
                              v-if="pref.api_header_key"
                              >Username</span
                            ><br /><span v-if=" pref.username">
                              {{ pref.username }}</span
                            ><span v-else>
                              - </span>
                            <br /><br />
                            <span
                              class="text-success"
                              >Token</span
                            ><br /><span v-if="pref.token">
                              {{ pref.token }}</span
                            ><span v-else>
                              - </span> -->
                          </td>
                          <td class="text-center">
                            <b-button
                              class="btn btn-info mr-1 btn-sm"
                              @click="editPrefModal(pref)"
                              ><i class="bx bx-pencil text-white"></i
                            ></b-button>
                            <b-button
                              class="btn btn-danger btn-sm"
                              @click="deletePref(pref.id_pref)"
                              ><i class="bx bx-trash text-white"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%"><b>Type</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.10.30.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Key</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.11.42.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>{{$t("malware.api-name")}}</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.44.21.XXX.XXX"
                          />
                        </td>
                      </tr>
                    </thead>
                      </table> -->
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <div class="d-flex align-items-left justify-content-left">
              <i class="bx bx-data bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >ELASTIC</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Elastic</h5>
                <div class="row mb-2">
                  <div class="col-6">-</div>
                  <div class="col-6 text-right">
                    <b-button
                      class="btn btn-success mr-1 btn-sm text-white"
                      @click="addPrefModal('elastic')"
                      ><i class="bx bx-plus text-white"> </i>
                      <span class="text-white">{{
                        $t("malware.add-preference")
                      }}</span></b-button
                    >
                  </div>
                </div>
                <div class="table-responsive">
                  <div>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            {{ $t("malware.type") }} & {{ $t("malware.key") }}
                          </th>
                          <th>{{ $t("malware.api-name") }}</th>
                          <th>Detail</th>
                          <th width="10%" class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="pref in tableDataElastic"
                          :key="pref.id_pref"
                        >
                          <td>
                            <span class="text-success">{{
                              $t("malware.type")
                            }}</span
                            ><br /><span> {{ pref.type }}</span
                            ><br /><br />
                            <span class="text-success">{{
                              $t("malware.key")
                            }}</span
                            ><br /><span> {{ pref.key }}</span>
                          </td>
                          <td>{{ pref.api_name }}</td>
                          <td>
                            <span class="text-success" v-if="pref.api_host"
                              >Api Host</span
                            >
                            <br /><span> {{ pref.api_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_host"
                              >Api Header Host</span
                            >
                            <br />
                            <span> {{ pref.api_header_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_key"
                              >Api Header Key</span
                            ><br /><span>
                              {{ pref.api_header_key_secret }}</span
                            >
                          </td>
                          <td class="text-center">
                            <b-button
                              class="btn btn-info mr-1 btn-sm"
                              @click="editPrefModal(pref)"
                              ><i class="bx bx-pencil text-white"></i
                            ></b-button>
                            <b-button
                              class="btn btn-danger btn-sm"
                              @click="deletePref(pref.id_pref)"
                              ><i class="bx bx-trash text-white"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%"><b>Type</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.10.30.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Key</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.11.42.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>{{$t("malware.api-name")}}</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.44.21.XXX.XXX"
                          />
                        </td>
                      </tr>
                    </thead>
                      </table> -->
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <div class="d-flex align-items-left justify-content-left">
              <i class="bx bx-shape-circle bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >INTEGRATOR</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Integrator</h5>
                <div class="row mb-2">
                  <div class="col-6">-</div>
                  <div class="col-6 text-right">
                    <b-button
                      class="btn btn-success mr-1 btn-sm text-white"
                      @click="addPrefModal('integrator')"
                      ><i class="bx bx-plus text-white"> </i>
                      <span class="text-white">{{
                        $t("malware.add-preference")
                      }}</span></b-button
                    >
                  </div>
                </div>
                <div class="table-responsive">
                  <div>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            {{ $t("malware.type") }} & {{ $t("malware.key") }}
                          </th>
                          <th>{{ $t("malware.api-name") }}</th>
                          <th>Detail</th>
                          <th width="10%" class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="pref in tableDataIntegrator"
                          :key="pref.id_pref"
                        >
                          <td>
                            <span class="text-success">{{
                              $t("malware.type")
                            }}</span
                            ><br /><span> {{ pref.type }}</span
                            ><br /><br />
                            <span class="text-success">{{
                              $t("malware.key")
                            }}</span
                            ><br /><span> {{ pref.key }}</span>
                          </td>
                          <td>{{ pref.api_name }}</td>
                          <td>
                            <span class="text-success" v-if="pref.api_host"
                              >Api Host</span
                            >
                            <br /><span> {{ pref.api_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_host"
                              >Api Header Host</span
                            >
                            <br />
                            <span> {{ pref.api_header_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_key"
                              >Api Header Key</span
                            ><br /><span>
                              {{ pref.api_header_key_secret }}</span
                            >
                          </td>
                          <td class="text-center">
                            <b-button
                              class="btn btn-info mr-1 btn-sm"
                              @click="editPrefModal(pref)"
                              ><i class="bx bx-pencil text-white"></i
                            ></b-button>
                            <b-button
                              class="btn btn-danger btn-sm"
                              @click="deletePref(pref.id_pref)"
                              ><i class="bx bx-trash text-white"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%"><b>Type</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.10.30.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Key</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.11.42.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>{{$t("malware.api-name")}}</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.44.21.XXX.XXX"
                          />
                        </td>
                      </tr>
                    </thead>
                      </table> -->
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <div class="d-flex align-items-left justify-content-left">
              <i class="bx bx-cog bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >RAPID API</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">Rapid API</h5>
                <div class="row mb-2">
                  <div class="col-6">-</div>
                  <div class="col-6 text-right">
                    <b-button
                      class="btn btn-success mr-1 btn-sm text-white"
                      @click="addPrefModal('rapid')"
                      ><i class="bx bx-plus text-white"> </i>
                      <span class="text-white">{{
                        $t("malware.add-preference")
                      }}</span></b-button
                    >
                  </div>
                </div>
                <div class="table-responsive">
                  <div>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            {{ $t("malware.type") }} & {{ $t("malware.key") }}
                          </th>
                          <th>{{ $t("malware.api-name") }}</th>
                          <th>Detail</th>
                          <th width="10%" class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pref in tableDataRapid" :key="pref.id_pref">
                          <td>
                            <span class="text-success">{{
                              $t("malware.type")
                            }}</span
                            ><br /><span> {{ pref.type }}</span
                            ><br /><br />
                            <span class="text-success">{{
                              $t("malware.key")
                            }}</span
                            ><br /><span> {{ pref.key }}</span>
                          </td>
                          <td>{{ pref.api_name }}</td>
                          <td>
                            <span class="text-success" v-if="pref.api_host"
                              >Api Host</span
                            >
                            <br /><span> {{ pref.api_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_host"
                              >Api Header Host</span
                            >
                            <br />
                            <span> {{ pref.api_header_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_key"
                              >Api Header Key</span
                            ><br /><span>
                              {{ pref.api_header_key_secret }}</span
                            >
                          </td>
                          <td class="text-center">
                            <b-button
                              class="btn btn-info mr-1 btn-sm"
                              @click="editPrefModal(pref)"
                              ><i class="bx bx-pencil text-white"></i
                            ></b-button>
                            <b-button
                              class="btn btn-danger btn-sm"
                              @click="deletePref(pref.id_pref)"
                              ><i class="bx bx-trash text-white"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%"><b>Type</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.10.30.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Key</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.11.42.XXX.XXX"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>{{$t("malware.api-name")}}</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            value="http://10.44.21.XXX.XXX"
                          />
                        </td>
                      </tr>
                    </thead>
                      </table> -->
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab title-item-class="mb-2">
          <template v-slot:title>
            <div class="d-flex align-items-left justify-content-left">
              <i class="bx bx-mail-send bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2"
                >MAIL SENDER</span
              >
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">
                  {{ $t("malware.mail-configuration") }}
                </h5>
                <div class="table-responsive">
                  <table class="table bordered table text-left">
                    <thead>
                      <tr>
                        <td width="30%"><b>Host</b></td>
                        <td width="70%">
                          <input
                            v-model="form.mail.host"
                            type="text"
                            class="form-control"
                          />
                        </td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <td width="30%"><b>Port</b></td>
                        <td width="70%">
                          <input
                            v-model="form.mail.port"
                            type="text"
                            class="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Encryption</b></td>
                        <td width="70%">
                          <select
                            class="custom-select"
                            v-model="form.mail.encryption"
                          >
                            <option value="ssl">SSL</option>
                            <option value="tls">TLS</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>From Address</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            v-model="form.mail.from_address"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>From Name</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            v-model="form.mail.from_name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Username</b></td>
                        <td width="70%">
                          <input
                            type="text"
                            class="form-control"
                            v-model="form.mail.username"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="30%"><b>Password</b></td>
                        <td width="70%">
                          <input
                            type="password"
                            class="form-control"
                            v-model="form.mail.password"
                          />
                        </td>
                      </tr>
                    </thead>
                  </table>
                  <b-button
                    variant="primary"
                    class="float-right px-4"
                    @click="saveMailConfig"
                    :disabled="
                      checkresult.status === false || loading.check == true
                        ? true
                        : false
                    "
                  >
                    <i class="bx bx-save font-size-16 align-middle mr-2"></i>
                    <span
                      class="d-xl-inline d-lg-none d-md-none"
                      v-if="loading.save"
                      >{{ $t("button.saving") }}</span
                    >
                    <span
                      class="d-xl-inline d-lg-none d-md-none"
                      v-if="!loading.save"
                      >{{ $t("button.save") }}</span
                    >
                  </b-button>
                  <b-button
                    variant="light"
                    class="float-right px-4 mr-2"
                    @click="checkConnection"
                  >
                    <span v-if="!loading.check">
                      <i
                        class="bx bx-broadcast font-size-16 align-middle mr-2"
                      ></i>
                      <span class="d-xl-inline d-lg-none d-md-none"
                        >Check Connection</span
                      >
                    </span>
                    <span v-if="loading.check">
                      <i
                        class="bx bx-broadcast bx-flashing font-size-16 align-middle mr-2 text-warning"
                      ></i>
                      <span class="d-xl-inline d-lg-none d-md-none text-warning"
                        >Checking Connection...</span
                      >
                    </span>
                  </b-button>
                  <span
                    v-if="checkresult.status !== ''"
                    class="float-right d-inline-block p-1 rounded mr-2"
                    :class="checkresult.status ? 'text-success' : 'text-danger'"
                  >
                    <span v-if="checkresult.status === true">
                      Success
                      <i class="bx bxs-check-circle p-2"></i>
                    </span>
                    <span v-if="checkresult.status === false">
                      Failed
                      <i class="bx bxs-x-circle p-2"></i>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <div class="d-flex align-items-left justify-content-left">
              <i class="bx bx-dots-horizontal bx-md check-nav-icon"></i>
              <span class="flex-grow-1 font-weight-bold my-auto mx-2">{{
                $t("malware.other")
              }}</span>
            </div>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h5 class="font-weight-bold mb-4">{{ $t("malware.other") }}</h5>
                <div class="row mb-2">
                  <div class="col-6">-</div>
                  <div class="col-6 text-right">
                    <b-button
                      class="btn btn-success mr-1 btn-sm text-white"
                      @click="addPrefModal('etc')"
                      ><i class="bx bx-plus text-white"> </i>
                      <span class="text-white">{{
                        $t("malware.add-preference")
                      }}</span></b-button
                    >
                  </div>
                </div>
                <div class="table-responsive">
                  <div>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            {{ $t("malware.type") }} & {{ $t("malware.key") }}
                          </th>
                          <th>{{ $t("malware.api-name") }}</th>
                          <th>Detail</th>
                          <th width="10%" class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pref in tableDataEtc" :key="pref.id_pref">
                          <td>
                            <span class="text-success">{{
                              $t("malware.type")
                            }}</span
                            ><br /><span> {{ pref.type }}</span
                            ><br /><br />
                            <span class="text-success">{{
                              $t("malware.key")
                            }}</span
                            ><br /><span> {{ pref.key }}</span>
                          </td>
                          <td>{{ pref.api_name }}</td>
                          <td>
                            <span class="text-success" v-if="pref.api_host"
                              >Api Host</span
                            >
                            <br /><span> {{ pref.api_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_host"
                              >Api Header Host</span
                            >
                            <br />
                            <span> {{ pref.api_header_host_secret }}</span
                            ><br /><br />
                            <span
                              class="text-success"
                              v-if="pref.api_header_key"
                              >Api Header Key</span
                            ><br /><span>
                              {{ pref.api_header_key_secret }}</span
                            >
                          </td>
                          <td class="text-center">
                            <b-button
                              class="btn btn-info mr-1 btn-sm"
                              @click="editPrefModal(pref)"
                              ><i class="bx bx-pencil text-white"></i
                            ></b-button>
                            <b-button
                              class="btn btn-danger btn-sm"
                              @click="deletePref(pref.id_pref)"
                              ><i class="bx bx-trash text-white"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>

      <b-modal
        id="modal-add"
        centered
        :title="$t('button.add')"
        title-class="font-18"
        @ok="addPref"
        hide-footer
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="validationCustom01">{{ $t("malware.type") }}</label>
              <input
                id="validationCustom01"
                type="text"
                class="form-control bg-light"
                :placeholder="$t('malware.type')"
                v-model="form.pref.type"
                :class="{
                  'is-invalid': submitted && $v.form.pref.type.$error,
                }"
                readonly
                v-if="
                  form.pref.type == 'sandbox' ||
                  form.pref.type == 'rapid' ||
                  form.pref.type == 'elastic'
                "
              />

              <input
                id="validationCustom01"
                type="text"
                class="form-control"
                :placeholder="$t('malware.type')"
                v-model="form.pref.type"
                :class="{
                  'is-invalid': submitted && $v.form.pref.type.$error,
                }"
                v-else
              />
              <div
                v-if="submitted && $v.form.pref.type.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.type.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div
              class="form-group"
              v-if="form.pref.type == 'sandbox' || form.pref.type == 'elastic'"
            >
              <label for="validationCustom11">{{ $t("malware.key") }}</label>
              <select
                class="form-control"
                id="key"
                :placeholder="$t('malware.key')"
                v-model="form.pref.key"
                :class="{
                  'is-invalid': submitted && $v.form.pref.key.$error,
                }"
              >
                <option value="ahn_lab">Ahn Lab</option>
                <option value="checkpoint">Checkpoint</option>
              </select>
              <div
                v-if="submitted && $v.form.pref.key.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.key.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
            <div class="form-group" v-else>
              <label for="validationCustom02">{{ $t("malware.key") }}</label>
              <input
                id="validationCustom02"
                type="text"
                class="form-control"
                :placeholder="$t('malware.key')"
                v-model="form.pref.key"
                :class="{
                  'is-invalid': submitted && $v.form.pref.key.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.pref.key.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.key.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom03">{{
                $t("malware.api-name")
              }}</label>
              <input
                id="validationCustom03"
                type="text"
                class="form-control"
                :placeholder="$t('malware.api-name')"
                v-model="form.pref.api_name"
                :class="{
                  'is-invalid': submitted && $v.form.pref.api_name.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.pref.api_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.api_name.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom04">Api Host</label>
              <input
                id="validationCustom04"
                type="text"
                class="form-control"
                placeholder="Api Host"
                v-model="form.pref.api_host"
                :class="{
                  'is-invalid': submitted && $v.form.pref.api_host.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.pref.api_host.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.api_host.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom05">Api Header Host </label>
              <input
                id="validationCustom05"
                type="text"
                class="form-control"
                placeholder="Api Header Host"
                v-model="form.pref.api_header_host"
              />
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom06">Api Header Key </label>
              <input
                id="validationCustom06"
                type="text"
                class="form-control"
                placeholder="Api Header Key"
                v-model="form.pref.api_header_key"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="validationCustom07">Username </label>
              <input
                id="validationCustom07"
                type="text"
                class="form-control"
                placeholder="Username"
                v-model="form.pref.username"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="validationCustom08">Password </label>
              <input
                id="validationCustom08"
                type="password"
                class="form-control"
                placeholder="Password"
                v-model="form.pref.password"
              />
            </div>
          </div>
          <!-- <div class="col-md-12">
              <div class="form-group">
                <label for="validationCustom09">Token </label>
                <input
                  id="validationCustom09"
                  type="text"
                  class="form-control"
                  placeholder="Token"
                  v-model="form.pref.token"
                />
              </div>
          </div> -->

          <div class="col-md-12">
            <div class="text-right">
              <b-button
                class="mt-3 mr-1"
                @click="$bvModal.hide('modal-add')"
                variant="danger"
                >{{ $t("button.cancel") }}</b-button
              >
              <b-button class="mt-3 mr-1" @click="addPref" variant="success">{{
                $t("button.save")
              }}</b-button>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="modal-edit-pref"
        centered
        :title="$t('button.update')"
        title-class="font-18"
        @ok="updatePref"
        hide-footer
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="validationCustom01">{{ $t("malware.type") }}</label>
              <input
                id="validationCustom01"
                type="text"
                class="form-control"
                :placeholder="$t('malware.type')"
                v-model="form.pref.type"
                :class="{
                  'is-invalid': submitted && $v.form.pref.type.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.pref.type.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.type.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" v-if="form.pref.type == 'sandbox'">
              <label for="validationCustom11">{{ $t("malware.key") }}</label>
              <select
                class="form-control"
                id="key"
                :placeholder="$t('malware.key')"
                v-model="form.pref.key"
                :class="{
                  'is-invalid': submitted && $v.form.pref.key.$error,
                }"
              >
                <option value="ahn_lab">Ahn Lab</option>
                <option value="checkpoint">Checkpoint</option>
              </select>
              <div
                v-if="submitted && $v.form.pref.key.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.key.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
            <div class="form-group" v-else>
              <label for="validationCustom02">{{ $t("malware.key") }}</label>
              <input
                id="validationCustom02"
                type="text"
                class="form-control"
                :placeholder="$t('malware.key')"
                v-model="form.pref.key"
                :class="{
                  'is-invalid': submitted && $v.form.pref.key.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.pref.key.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.key.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom03">{{
                $t("malware.api-name")
              }}</label>
              <input
                id="validationCustom03"
                type="text"
                class="form-control"
                :placeholder="$t('malware.api-name')"
                v-model="form.pref.api_name"
                :class="{
                  'is-invalid': submitted && $v.form.pref.api_name.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.pref.api_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.api_name.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom04">Api Host</label>
              <input
                id="validationCustom04"
                type="text"
                class="form-control"
                placeholder="Api Host"
                v-model="form.pref.api_host"
                :class="{
                  'is-invalid': submitted && $v.form.pref.api_host.$error,
                }"
              />
              <div
                v-if="submitted && $v.form.pref.api_host.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pref.api_host.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom05">Api Header Host </label>
              <input
                id="validationCustom05"
                type="text"
                class="form-control"
                placeholder="Api Header Host"
                v-model="form.pref.api_header_host"
              />
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom06">Api Header Key </label>
              <input
                id="validationCustom06"
                type="text"
                class="form-control"
                placeholder="Api Header Key"
                v-model="form.pref.api_header_key"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="validationCustom07">Username </label>
              <input
                id="validationCustom07"
                type="text"
                class="form-control"
                placeholder="Username"
                v-model="form.pref.username"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="validationCustom08">Password </label>
              <input
                id="validationCustom08"
                type="password"
                class="form-control"
                placeholder="Password"
                v-model="form.pref.password"
              />
            </div>
          </div>

          <div class="col-md-9" v-if="form.pref.type == 'sandbox'">
            <div class="form-group">
              <label for="validationCustom09">Token </label>
              <input
                id="validationCustom09"
                type="text"
                class="form-control"
                placeholder="Token"
                v-model="form.pref.token"
                readonly
              />
              <br />
              <span v-if="expired_token"
                >Expired :
                <span class="text-danger">{{ expired_token }}</span></span
              >
            </div>
          </div>

          <div class="col-md-3" v-if="form.pref.type == 'sandbox'">
            <label for="validationCustom08">&nbsp;</label>
            <div class="form-group">
              <b-button
                class="btn-block mr-1 mt-2"
                @click="generate(form.pref.key)"
                variant="primary"
                :disabled="form.pref.key == 'ahn_lab' ? false : true"
              >
                <b-spinner
                  v-if="login_generate"
                  label="Loading ..."
                  small
                ></b-spinner>
                <span v-if="login_generate"> &nbsp;Loading </span>
                <span v-else> Generate </span>
              </b-button>
            </div>
          </div>

          <div class="col-md-12">
            <hr />
            <div class="text-right">
              <b-button
                class="mt-3 mr-1"
                @click="closePrefModal()"
                variant="danger"
                >{{ $t("button.cancel") }}</b-button
              >
              <b-button
                class="mt-3 mr-1"
                @click="updatePref"
                variant="success"
                >{{ $t("button.save") }}</b-button
              >
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import MailConfigService from "@/helpers/mailconfig.service";
import PreferencesServices from "@/helpers/preferences.service";
import { userService } from "@/helpers/authservice/user.service";
import { required, sameAs } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "SETTING",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: this.$t("malware.setting"),
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: this.$t("malware.setting"),
          href: "/",
        },
      ],
      theme: localStorage.getItem("theme"),
      expired_token: "",
      login_generate: false,
      tableData: [],
      tableDataSandbox: [],
      tableDataRapid: [],
      tableDataElastic: [],
      tableDataIntegrator: [],
      tableDataRapid: [],
      tableDataEtc: [],
      form: {
        mail: {
          id_config: 1,
          host: "",
          port: "",
          encryption: "ssl",
          from_name: "",
          from_address: "",
          username: "",
          password: "",
        },
        pref: {
          id_pref: "",
          type: "",
          key: "",
          api_name: "",
          api_host: "",
          api_header_host: "",
          api_header_key: "",
          api_header_host_secret: "",
          api_header_key_secret: "",
          username: "",
          password: "",
          token: "",
        },
      },
      checkresult: {
        status: "",
        err: "",
      },
      checkerr: "",
      loading: {
        check: false,
        save: false,
      },

      show: {
        new: false,
        conf: false,
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      pref: {
        type: { required },
        key: { required },
        api_name: { required },
        api_host: { required },
        api_header_host: { required },
        api_header_key: { required },
      },
    },
  },
  methods: {
    getMailConfig() {
      let ferr = 0;
      MailConfigService.getConfig(this.form.mail.id_config)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getMailConfig();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            // console.log("res", response.data);
            this.form.mail.id_config = response.data.data.id_config;
            this.form.mail.host = response.data.data.host;
            this.form.mail.port = response.data.data.port;
            this.form.mail.encryption = response.data.data.encryption;
            this.form.mail.from_name = response.data.data.from_name;
            this.form.mail.from_address = response.data.data.from_address;
            this.form.mail.username = response.data.data.username;
            this.form.mail.password = response.data.data.password;
            // console.log("ress conf ", response);
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            this.loading.save = false;
            // console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getMailConfig();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },
    saveMailConfig() {
      let ferr = 0;
      this.loading.save = true;
      MailConfigService.getConfig(this.form.mail.id_config)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.saveMailConfig();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.loading.save = false;
            this.form.mail.id_config = response.data.data.id_config;
            this.form.mail.host = response.data.data.host;
            this.form.mail.port = response.data.data.port;
            this.form.mail.encryption = response.data.data.encryption;
            this.form.mail.from_name = response.data.data.from_name;
            this.form.mail.from_address = response.data.data.from_address;
            this.form.mail.username = response.data.data.username;
            this.form.mail.password = response.data.data.password;
            // console.log("ress conf ", response);
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
            this.loading.save = false;
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.saveMailConfig();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              this.loading.save = false;
              console.log(err);
              // this.loading = false;
            }
          }
        });
    },
    checkConnection() {
      let ferr = 0;
      this.loading.check = true;
      MailConfigService.check(this.form.mail)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.checkConnection();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            // console.log("ress check conn ", response);
            this.checkresult.status = response.data.data.status;
            this.loading.check = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.checkConnection();
          } else {
            this.checkresult.status = false;
            this.loading.check = false;
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err check conn ", err.response);
            }
            // this.loading = false;
          }
        });
    },

    getPref() {
      let ferr = 0;
      this.expired_token = "";
      PreferencesServices.getPreference()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPref();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            // console.log(response.data.data);
            ferr = 2;
            this.tableData = [];
            this.tableDataSandbox = [];
            this.tableDataRapid = [];
            this.tableDataEtc = [];
            this.tableDataElastic = [];
            this.tableDataIntegrator = [];
            let pref = response.data.data;
            // console.log('pref', pref);

            pref.forEach((val) => {
              if (val.api_header_host !== null) {
                if (val.api_header_host.length > 10) {
                  var secret_host =
                    "*********" + val.api_header_host.slice(10, 1000);
                } else {
                  var secret_host = val.api_header_host;
                }
              }

              if (val.api_header_key !== null) {
                if (val.api_header_key.length > 10) {
                  var secret_key =
                    "*********" + val.api_header_key.slice(10, 1000);
                } else {
                  var secret_key = val.api_header_key;
                }
              }

              const data = {
                id_pref: val.id_pref,
                type: val.type,
                key: val.key,
                api_name: val.api_name,
                api_host: val.api_host,
                api_header_host: val.api_header_host,
                api_header_key: val.api_header_key,
                api_host_secret: "*********" + val.api_host.slice(10, 1000),
                api_header_host_secret: secret_host,
                api_header_key_secret: secret_key,
                created_at: val.created_at,
                updated_at: val.updated_at,
              };

              if (val.type == "sandbox") {
                // console.log("push", val.id_pref);
                this.tableDataSandbox.push(data);
              } else if (val.type == "rapid") {
                this.tableDataRapid.push(data);
              } else if (val.type == "elastic") {
                this.tableDataElastic.push(data);
              } else if (val.type == "integrator") {
                this.tableDataIntegrator.push(data);
              } else {
                this.tableDataEtc.push(data);
              }
            });
          }
        })
        .catch((err) => {
          console.log("err", err.response.status);
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPref();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    addPrefModal(value) {
      // this.resetForm();
      if (value == "sandbox") {
        this.form.pref.type = "sandbox";
      } else if (value == "rapid") {
        this.form.pref.type = "rapid";
      } else if (value == "elastic") {
        this.form.pref.type = "elastic";
      } else if (value == "integrator") {
        this.form.pref.type = "integrator";
      } else {
        this.form.pref.type = "";
      }

      this.form.pref.id_pref = "";
      this.form.pref.key = "";
      this.form.pref.api_name = "";
      this.form.pref.api_host = "";
      this.form.pref.api_header_host = "";
      this.form.pref.api_header_key = "";
      this.form.pref.username = "";
      this.form.pref.password = "";
      this.form.pref.token = "";
      this.$bvModal.show("modal-add");
    },

    closePrefModal() {
      this.$bvModal.hide("modal-add");
      this.$bvModal.hide("modal-edit-pref");
    },

    editPrefModal(pref) {
      let ferr = 0;
      this.loading_detail = true;
      PreferencesServices.detailPreference(pref.id_pref)
        .then((response) => {
          // console.log("berhasil", response);
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.addPreference(e);
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            // console.log('detail', response.data.data);
            // this.getPref();
            // this.closePrefModal();
            // this.resetForm();
            // this.$v.$reset();
            let pref = response.data.data;
            this.$bvModal.show("modal-edit-pref");
            this.form.pref.id_pref = pref.id_pref;
            this.form.pref.type = pref.type;
            this.form.pref.key = pref.key;
            this.form.pref.api_name = pref.api_name;
            this.form.pref.api_host = pref.api_host;
            this.form.pref.api_header_host = pref.api_header_host;
            this.form.pref.api_header_key = pref.api_header_key;
            this.form.pref.username = pref.username;
            this.form.pref.token = pref.secret_token;
            this.expired_token = pref.expired_token;
            this.form.pref.password = pref.password;
            this.loading_detail = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.addPref();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading_detail = false;
            }
          }
        });
    },

    addPref(e) {
      let ferr = 0;
      this.submitted = true;
      this.$v.form.pref.$touch();
      if (
        this.form.pref.type == "" ||
        this.form.pref.key == "" ||
        this.form.pref.api_name == "" ||
        this.form.pref.api_host == ""
      ) {
        e.preventDefault();
      } else {
        const data = {
          type: this.form.pref.type,
          key: this.form.pref.key,
          api_name: this.form.pref.api_name,
          api_host: this.form.pref.api_host,
          api_header_host: this.form.pref.api_header_host,
          api_header_key: this.form.pref.api_header_key,
          username: this.form.pref.username,
          password: this.form.pref.password,
        };
        // console.log('log pref', data);
        PreferencesServices.addPreference(data)
          .then((response) => {
            // console.log("berhasil", response);
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.addPreference(e);
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              // console.log('swal open');
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.getPref();
              this.closePrefModal();
              this.resetForm();
              this.$v.$reset();
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.addPref();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.loading = false;
              }
            }
          });
      }
    },

    updatePref() {
      let ferr = 0;
      this.submitted = true;
      this.$v.form.pref.$touch();
      if (
        this.form.pref.type == "" ||
        this.form.pref.key == "" ||
        this.form.pref.api_name == "" ||
        this.form.pref.api_host == ""
      ) {
        e.preventDefault();
      } else {
        const data = {
          type: this.form.pref.type,
          key: this.form.pref.key,
          api_name: this.form.pref.api_name,
          api_host: this.form.pref.api_host,
          api_header_host: this.form.pref.api_header_host,
          api_header_key: this.form.pref.api_header_key,
          username: this.form.pref.username,
          password: this.form.pref.password,
          token: this.form.pref.token,
        };
        // console.log('log', data);
        PreferencesServices.updatePreference(this.form.pref.id_pref, data)
          .then((response) => {
            // console.log('berhasil', response);
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.updatePref(e);
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              // console.log('swal open');
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.getPref();
              this.closePrefModal();
              this.resetForm();
              this.$v.$reset();
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.updatePref();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.loading = false;
              }
            }
          });
      }
    },

    deletePref(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel"),
        confirmButtonText: this.$t("button.deleted"),
      }).then((result) => {
        // console.log("swift" + id, result.value);
        if (result.value) {
          this.delPref(id);
          // console.log('id user', id);
        }
      });
    },

    delPref(id) {
      let ferr = 0;
      // console.log('id del', id);
      PreferencesServices.deletePreference(id)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.deletePref(id);
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.getPref("refresh");
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.delPref();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },

    resetForm() {
      setTimeout(() => {
        this.form.pref.id_pref = "";
        this.form.pref.type = "";
        this.form.pref.key = "";
        this.form.pref.api_name = "";
        this.form.pref.api_host = "";
        this.form.pref.api_header_host = "";
        this.form.pref.api_header_key = "";
        this.form.pref.username = "";
        this.form.pref.password = "";
        this.form.pref.token = "";
      }, 2000);
    },

    generate(value) {
      this.login_generate = true;
      let ferr = 0;
      const data = {
        key: value,
      };
      console.log(data);
      PreferencesServices.generateToken(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPref();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            console.log("generate", response.data.data);
            let res = response.data.data;
            this.form.pref.token = res.token;
            this.expired_token = res.expired;
            this.login_generate = false;
          }
        })
        .catch((err) => {
          console.log("err", err.response.status);
          this.login_generate = false;
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPref();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },
  },
  mounted() {
    this.getMailConfig();
    this.getPref();
  },
};
</script>
